export const loadState = (localStoreName) => {
    try {
        const serializedState = localStorage.getItem(localStoreName);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (key, state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(key, serializedState);
    } catch (err) {
        // ignore write errors
    }
};

export const removeStoreById = (id) => {
    try {
        localStorage.removeItem(id);
    } catch (err) {
        // ignore write errors
    }
};
